import { Component, OnInit, Input } from '@angular/core';
import { IGlobalEmployeeInfoModel } from '../../../entities-api/IGlobalEmployeeInfoModel';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'opm-user-photo',
  templateUrl: './user-photo.component.html',
  styleUrls: ['./user-photo.component.less'],
  standalone: false
})
export class UserPhotoComponent implements OnInit {

  constructor(private userService: UserService) { }

  @Input() user: IGlobalEmployeeInfoModel;
  userHasImage: boolean;
  userInitials: string = "";
  userWithoutInitials: boolean = false;

  ngOnInit(): void {
    this.initializeUserImage();
  }

  private initializeUserImage(): void {
    this.userService
      .getCurrentUserImage(this.user.GlobalPersonUid)
      .then(data => {
        if (data) {
          this.userHasImage = true;
        } else {
          this.userHasImage = false;

          this.setUserInitials();
        }
      });
  }

  private setUserInitials(): void {
    if (this.user.PreferredFullName != null) {
      var fistLastname: string[] = this.user.PreferredFullName.split(',');
      this.userInitials = fistLastname[0].trim()[0] + fistLastname[1].trim()[0];
    }

    if (this.userInitials.length < 2) {
      this.userWithoutInitials = true;
      this.userInitials = "";
    }
  }

}
